import type { CSSProperties } from "react";

/** Sets --kid for a subtree, so that kid's colour is the accent for everything inside it. */
export function kidStyle(colour: string): CSSProperties {
  return { "--kid": colour } as CSSProperties;
}
